import React from 'react'
import { Panel, Card } from '../../../_components'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayModal, removePurchaseSeeds } from '../../../_slices/AppSlice'
import { formatCurrency } from '../../../_utils'

export default function SectionI() {
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      title: state.application.displayModal?.title,
      flag: state.application.displayModal?.flag,
      revenue: state.application.revenue
    }
  } )

  const handleDeleteItem = async ( idx ) => {
    await dispatch( removePurchaseSeeds( { idx } ) )
  }

  const handleAdd = async ( tag, slug ) => {
    dispatch( setDisplayModal( { flag: true, title: slug, tag } ) )
  }

  const handleCalculateFooter = ( tag ) => {
    if( state[ tag ].length > 0 ) {
     return state[tag].filter( item => { 
        return parseFloat( item.qty ) > 0 && parseFloat( item.rate ) > 0 
      } )
      .map( val => parseFloat( val.amount ) )
      .reduce( ( acc, curr ) => {
        return acc + curr 
      }, 0 )
    }
  }

  return (
    <Card title="Revenue">
        <Panel label="Section I: Revenue">
        {/* <button className="text-xs bg-blue-700 text-white px-2 py-1 my-2 rounded" type="button" onClick={() => }>
            {`Add`}
        </button> */}
        <div className="grid grid-cols-1">
            <table className="w-full border">
              <thead className="text-xs bg-gray-200 font-bold p-2 uppercase">
                  <th className="p-2 text-start">Actions</th>
                  <th className="text-start">{`Season`}</th>
                  <th className="text-start">{`Category`}</th>
                  <th className="text-start">{`Qty( Kgs )`}</th>
                  <th className="text-start">{`Rate`}</th>
                  <th className="text-start">{`Amount(UGX)`}</th>
              </thead>
              <tbody>
                  {[
                    { name: "Rice Consumed at Home", slug: "rice consumed", tag: "revenue" },
                    { name: "Rice Sold", slug: "rice sold", tag: "revenue" }
                  ].map( ( val, index ) => {
                      return (
                      <tr className="text-xs p-2 text-start border border-gray-300">
                          <td className="p-2 flex">
                            <button onClick={ () => handleAdd( val.tag, val.slug ) } className="rounded bg-purple-700 px-2 text-white" type="button">
                              {`+`}
                            </button>
                          </td>
                          <td>{val.name}</td>
                          <td>{state.revenue.length > 0 && state.revenue.filter( item => item.title === val.slug )[ 0 ]?.category}</td>
                          <td>{state.revenue.length > 0 && state.revenue.filter( item => item.title === val.slug )[ 0 ]?.qty}</td>
                          <td>{state.revenue.length > 0 && state.revenue.filter( item => item.title === val.slug )[ 0 ]?.rate}</td>
                          <td>{state.revenue.length > 0 && state.revenue.filter( item => item.title === val.slug )[ 0 ]?.amount}</td>
                      </tr>
                      )
                  } )}
              </tbody>
              <tfoot className="bg-gray-400 text-xs uppercase font-bold text-start">
                <td></td>
                <td>{`Total`}</td>
                <td></td>
                <td></td>
                <td></td>
                <td>{handleCalculateFooter("revenue")}</td>
              </tfoot>
            </table>
        </div>
      </Panel>
    </Card>
  )
}
